export default __webpack_public_path__ + "static/media/bookmarked-dark.19261e9c.svg";